var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGlobe = function SvgGlobe(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 16.75C13.1683 16.75 16.75 13.1683 16.75 8.75C16.75 4.33172 13.1683 0.75 8.75 0.75C4.33172 0.75 0.75 4.33172 0.75 8.75C0.75 13.1683 4.33172 16.75 8.75 16.75Z",
    stroke: "#52E3C2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 16.75C10.4069 16.75 11.75 13.1683 11.75 8.75C11.75 4.33172 10.4069 0.75 8.75 0.75C7.09315 0.75 5.75 4.33172 5.75 8.75C5.75 13.1683 7.09315 16.75 8.75 16.75Z",
    stroke: "#52E3C2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 8.75H16.75",
    stroke: "#52E3C2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47009 2.75C4.92853 4.03622 6.8053 4.7472 8.74988 4.75C10.6945 4.7472 12.5717 4.03622 14.0302 2.75",
    stroke: "#52E3C2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0302 14.75C12.5717 13.4638 10.6945 12.7528 8.74988 12.75C6.8053 12.7528 4.92853 13.4638 3.47009 14.75",
    stroke: "#52E3C2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGlobe);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Globe.86f82c60.svg";